module.exports = __webpack_public_path__ + "img/model_left.73607a57.svg";